import { gql } from '@apollo/client'

export const CREATE_REQUESTED_INFO_MUTATION = gql`
  mutation createRequestedInfo($attributes: ActionInput!) {
    createRequestedInfo(attributes: $attributes) {
      id
      type
      processingId
      date
      userId
    }
  }
`
